export default {"src":"/_next/static/media/frame-dog.9a0ca323.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};